import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import themeOverrides from './theme';

const customTheme = extendTheme(themeOverrides);

const ThemeProvider: React.FC<{}> = ({
  children,
}: {
  children: React.ReactNode;
}) => <ChakraProvider theme={customTheme}>{children}</ChakraProvider>;

export default ThemeProvider;
